export enum AIPluginName {
  OpenAI = 'openai',
  Groq = 'groq',
  Tavily = 'tavily',
}

enum OpenAIModel {
  GPT3_5_Turbo = 'gpt-3.5-turbo-0125',
  GPT4_Turbo = 'gpt-4-turbo',
  GPT4o = 'gpt-4o',
  GPT4o_Mini = 'gpt-4o-mini',
  GPT3o_Mini = 'o3-mini',
}

enum GroqModel {
  Llama_Instant = 'llama-3.1-8b-instant',
  Llama_Versatile = 'llama-3.3-70b-versatile',
}

enum TavilyModel {
  default = 'default',
}

export const AI_PLUGINS = {
  [AIPluginName.OpenAI]: OpenAIModel,
  [AIPluginName.Groq]: GroqModel,
  [AIPluginName.Tavily]: TavilyModel
} as const

type aiPlugins = typeof AI_PLUGINS
export type AiPlugins = aiPlugins[keyof aiPlugins]

export type AiModels = OpenAIModel | GroqModel | TavilyModel
